module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Toilet-34da40619aa26db5c989e4af0f51e98243bb73e8b76ad6b3bb418c4503f316d5.svg";